<div *ngIf="dropdownType === 'YesNo'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="yesNoOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeYesNo($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="yesNoOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeYesNo($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'Entry'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="entryOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangEntry($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="entryOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangEntry($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'InnuvaWorkCenter'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="optionsNull" [items]="innuvaWorkCenterOptions"
    [valueColumn]="'fullValue'" [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple"
    [ngModel]="selectedValue" (ngModelChange)="onSelectedValueChangeInnuvaWorkCenter($event)"
    [placeHolder]="placeHolder" name="selectedValue" [required]="optionsNull ? false : required"
    [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="innuvaWorkCenterOptions"
    [valueColumn]="'fullValue'" [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple"
    [ngModel]="selectedValue" (ngModelChange)="onSelectedValueChangeInnuvaWorkCenter($event)"
    [placeHolder]="placeHolder" name="selectedValue" [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>

  <span *ngIf="optionsNull">No hay centros en Innuva nómina que no estén ya parametrizados</span>
</div>

<div *ngIf="dropdownType === 'WorkCenter'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="optionsNull" [items]="workCenterOptions"
    [valueColumn]="'value'" [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple"
    [ngModel]="selectedValue" (ngModelChange)="onSelectedValueChangeWorkCenter($event)" [placeHolder]="placeHolder"
    name="selectedValue" [required]="optionsNull ? false : required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="workCenterOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeWorkCenter($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>

  <span *ngIf="optionsNull">No hay centros parametrizados en la empresa</span>
</div>

<div *ngIf="dropdownType === 'AttendanceView'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="attendanceViewOptions"
    [valueColumn]="'value'" [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple"
    [ngModel]="selectedValue" (ngModelChange)="onSelectedValueChangeAttendanceView($event)" [placeHolder]="placeHolder"
    name="selectedValue" [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="attendanceViewOptions"
    [valueColumn]="'value'" [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple"
    [ngModel]="selectedValue" (ngModelChange)="onSelectedValueChangeAttendanceView($event)" [placeHolder]="placeHolder"
    name="selectedValue" [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'AttendanceType'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="optionsNull" [items]="attendanceTypeOptions"
    [valueColumn]="'value'" [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple"
    [ngModel]="selectedValue" (ngModelChange)="onSelectedValueChangeAttendanceType($event)" [placeHolder]="placeHolder"
    name="selectedValue" [required]=" optionsNull ? false : required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="attendanceTypeOptions"
    [valueColumn]="'value'" [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple"
    [ngModel]="selectedValue" (ngModelChange)="onSelectedValueChangeAttendanceType($event)" [placeHolder]="placeHolder"
    name="selectedValue" [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  {{selectedValue}}
  <span *ngIf="optionsNull">No hay tipos de marcajes parametrizados para la empresa</span>
</div>

<div *ngIf="dropdownType === 'TimeZone'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="timeZonesOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChange($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="timeZonesOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChange($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'PayRollType'" class='custom-tooltip'
  [ngbTooltip]="'Esto determina la fecha de antigüedad que aparece en la nómina'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="yesNoOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangePayRoll($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="yesNoOptions" [valueColumn]="'value'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangePayRoll($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'Users'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="users" [valueColumn]="'user1'"
    [descriptionColumns]="['nameWithNif']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeUsers($event, detailedData)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="users" [valueColumn]="'user1'"
    [descriptionColumns]="['nameWithNif']" [loading]="loading" [multiple]="multiple" [ngModel]="null"
    (ngModelChange)="onSelectedValueChangeUsers($event, detailedData)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">

  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'NetUsers'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="netUsers" [valueColumn]="'Id'"
    [descriptionColumns]="['Name','Surname']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeNetUsers($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="netUsers" [valueColumn]="'Id'"
    [descriptionColumns]="['Name','Surname']" [loading]="loading" [multiple]="multiple" [ngModel]="null"
    (ngModelChange)="onSelectedValueChangeNetUsers($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'HRUsers'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="hrUsers" [valueColumn]="'Id'"
    [descriptionColumns]="['Name','Surname']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeHRValidator($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="hrUsers" [valueColumn]="'Id'"
    [descriptionColumns]="['Name','Surname']" [loading]="loading" [multiple]="multiple" [ngModel]="null"
    (ngModelChange)="onSelectedValueChangeHRValidator($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'HolidayBagUsers'">
  <app-mat-select-filtered *ngIf="!disabledState" [disabled]="false" [items]="hrUsers" [valueColumn]="'Id'"
    [descriptionColumns]="['Name','Surname']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeHolidayBagValidator($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="disabledState" [disabled]="true" [items]="hrUsers" [valueColumn]="'Id'"
    [descriptionColumns]="['Name','Surname']" [loading]="loading" [multiple]="multiple" [ngModel]="null"
    (ngModelChange)="onSelectedValueChangeHolidayBagValidator($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'Section'">
  <app-mat-select-filtered [items]="sections" [valueColumn]="'section1'" [descriptionColumns]="['name']"
    [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeSection($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'DocCategories'">
  <label for="docCategoriesSelect" class="azul-a3Factura mb-0 col-md-14 label-category-position"
    [ngClass]="{'small-a3-doc-label': smallA3Doc }">
    Categoría
    <span class="star ng-star-inserted">*</span>
  </label>

  <dx-drop-down-box [(value)]="selectedItemsNumbers" [valueExpr]="'id'" [displayExpr]="'name'"
    [dataSource]="flatCategories" placeholder="" [showClearButton]="false" [contentTemplate]="contentTemplate"
    [dropDownOptions]="{ opened: true }" [ngStyle]="{ 'background-color': 'white' }"
    [ngClass]="{ 'custom-font-size': true, 'small-a3-doc-class': smallA3Doc }"
    (onValueChanged)="onSelectedValueChangeDocCategories($event)"
    [validationRules]="[{ type: 'required', message: 'Este campo es obligatorio' }]">

    <div *dxTemplate="let data of 'content'">
      <!-- Mostrar el spinner si está cargando -->
      <div *ngIf="isLoading" class="spinner">
        <i class="fa fa-spinner fa-spin"></i> Cargando categorías...
      </div>

      <!-- Mostrar el contenido cuando haya terminado de cargar -->
      <dx-tree-view *ngIf="!isLoading" [items]="categoriesA3Doc" displayExpr="name" [parentIdExpr]="'parentId'"
        selectionMode="multiple" [selectByClick]="true" [selectNodesRecursive]="true" showCheckBoxesMode="normal"
        [searchEnabled]="true" keyExpr="id" [selectedItemKeys]="[1]"
        (onItemSelectionChanged)="onSelectionChanged($event)" (onContentReady)="onTreeViewContentReady($event)">
      </dx-tree-view>
    </div>
  </dx-drop-down-box>
</div>


<div *ngIf="dropdownType === 'Companies'">
  <app-mat-select-filtered *ngIf="!getCompanyCode" [items]="companies" [valueColumn]="'company1'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeCompanies($event, multiple, detailedData)" [placeHolder]="placeHolder"
    name="selectedValue" [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
  <app-mat-select-filtered *ngIf="getCompanyCode" [items]="companies" [valueColumn]="'companyCode'"
    [descriptionColumns]="['name']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeCompanies($event, multiple, detailedData)" [placeHolder]="placeHolder"
    name="selectedValue" [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>

<div *ngIf="dropdownType === 'CostCenters'">
  <app-mat-select-filtered [items]="costCenters" [valueColumn]="'imputationGuid'"
    [descriptionColumns]="['imputationName']" [loading]="loading" [multiple]="multiple" [ngModel]="selectedValue"
    (ngModelChange)="onSelectedValueChangeCostCenter($event)" [placeHolder]="placeHolder" name="selectedValue"
    [required]="required" [emptyOption]="emptyOption">
  </app-mat-select-filtered>
</div>